// src/pages/About.js
import CmsPage from "../components/pages/CmsPage";

export default function About() {
  return (
    <CmsPage
      slug="about"
      fallbackTitle="About Us"
      fallbackContent=""
    />
  );
}
